
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hall-of-fame/[slug]",
      function () {
        return require("private-next-pages/hall-of-fame/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hall-of-fame/[slug]"])
      });
    }
  